/* FLOW: base firmness section (sections/product-firmness.liquid). Switching firmness here moves the
   drawing (--depth) and shows that firmness's text; "Bu sertliği seç" sets the "Sertlik" variant
   above, and a change made above is followed here. The press loop runs only while in view. */

if (!customElements.get('firmness-explorer')) {
  class FirmnessExplorer extends HTMLElement {
    connectedCallback() {
      this.inputs = [...this.querySelectorAll('input[type="radio"]')];
      this.details = [...this.querySelectorAll('[data-firmness]')];
      this.button = this.querySelector('[data-firmness-choose]');
      this.optionIndex = this.dataset.optionIndex;

      this.addEventListener('change', (e) => {
        if (this.inputs.includes(e.target)) this.show(e.target.value);
      });
      this.button?.addEventListener('click', () => this.choose());

      // the variant picker above: follow its firmness
      this.onPicker = (e) => {
        const input = e.target;
        if (this.optionIndex === '' || !input.matches?.(`variant-picker input[data-option-index="${this.optionIndex}"]`)) return;
        if (input.checked) this.select(input.value);
      };
      document.addEventListener('change', this.onPicker);

      const start = this.inputs.find((i) => i.checked) || this.inputs[0];
      if (start) this.select(start.value);

      this.observer = new IntersectionObserver(([entry]) => this.classList.toggle('is-live', entry.isIntersecting));
      this.observer.observe(this);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onPicker);
      this.observer?.disconnect();
    }

    current() {
      return this.inputs.find((i) => i.checked)?.value;
    }

    select(value) {
      const input = this.inputs.find((i) => i.value === value);
      if (!input) return;
      input.checked = true;
      this.show(value);
    }

    show(value) {
      const input = this.inputs.find((i) => i.value === value);
      if (input) this.style.setProperty('--depth', input.dataset.depth);
      this.details.forEach((d) => (d.hidden = d.dataset.firmness !== value));
      this.refreshButton();
    }

    pickerInput(value) {
      if (this.optionIndex === '' || value == null) return null;
      return document.querySelector(`variant-picker input[data-option-index="${this.optionIndex}"][value="${CSS.escape(value)}"]`);
    }

    refreshButton() {
      if (!this.button) return;
      const radio = this.pickerInput(this.current());
      const chosen = !!radio?.checked;
      this.button.hidden = !radio;
      this.button.disabled = chosen;
      this.button.querySelector('[data-choose-label]').hidden = chosen;
      this.button.querySelector('[data-chosen-label]').hidden = !chosen;
    }

    choose() {
      const radio = this.pickerInput(this.current());
      if (!radio) return;
      radio.checked = true;
      // the product page listens for this to switch the variant, price and button
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      radio.closest('variant-picker')?.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
      this.refreshButton();
    }
  }

  customElements.define('firmness-explorer', FirmnessExplorer);
}
